import { MaskedLines } from "@/components/Reveal";
import { motion } from "framer-motion";

export default function PageHero({ overline, lines, subtitle, testId = "page-hero" }) {
  return (
    <section
      data-testid={testId}
      className="relative pt-40 md:pt-52 pb-16 md:pb-24 border-b border-border overflow-hidden"
    >
      <div
        className="grain absolute inset-0 opacity-[0.15] pointer-events-none"
        aria-hidden
      />
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 relative">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="overline text-primary mb-6"
        >
          {overline}
        </motion.p>
        <h1 className="font-clash font-semibold tracking-tight text-4xl sm:text-6xl lg:text-7xl leading-[0.95]">
          <MaskedLines lines={lines} />
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-8 max-w-2xl text-lg text-muted-foreground leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
